export default __webpack_public_path__ + "static/nighthawk-slide-89e5b143da4e1097021f017f70195c14.png";